
  import { computed, defineComponent, onMounted, ref } from 'vue';
  import LinkButton from '@/ui/components/checklist/LinkButton.vue';
  import DragAndDropUpload from '@/ui/components/common/DragAndDropUpload.vue';
  import { Button } from '@/ui/components/Button';
  import { router } from '@/ui/routes';
  import TabletFrame from '@/_legacy/components/TabletFrame.vue';
  import ConductInspectionPreview from '@/_legacy/components/ConductInspection/ConductInspectionPreview.vue';
  import { useAiFileUpload } from '@/ui/concerns/checklist/useAiFileUpload';
  import { ConfirmationModal } from '@/ui/components/modals/ConfirmationModal';
  import { useChecklistSessionStorage } from '@/ui/concerns/useChecklistSessionStorage';
  import { Icon } from '@/ui/components/icon/Icon';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { hasAiBalance } from '@/ui/auth/auth';
  import { isAiPricingEnabled } from '@/ui/helpers/featureHelper';

  export default defineComponent({
    components: {
      Icon,
      LinkButton,
      DragAndDropUpload,
      Button,
      TabletFrame,
      ConfirmationModal,
      Tooltip,
      // @ts-ignore
      ConductInspectionPreview,
    },
    setup() {
      const {
        loading,
        uploadedFiles,
        clearPreview,
        aiTemplate,
        uploadAiTask,
        formats,
        types,
        onUseThisTemplateClick,
        onCustomizeTemplateClick,
      } = useAiFileUpload();

      const canContinue = computed(() => uploadedFiles.value.length > 0 && aiTemplate.value && !loading.value);
      const {
        exitAction,
        cleanAiForm,
      } = useChecklistSessionStorage();

      const hideModal = () => { leaveModalShow.value = false; };
      const showModal = () => { leaveModalShow.value = true; };
      const leaveModalShow = ref(false);

      onMounted(() => { cleanAiForm(); });

      const onFileUploadChange = (data: File[]) => {
        if (!data.length) {
          return;
        }

        uploadedFiles.value = data;
        uploadAiTask.run();
      };

      const onGoBack = () => { router.push({ name: 'checklistChooseMethod' }); };

      const onQuit = () => {
        if (!uploadedFiles.value.length) {
          exitAction();

          return;
        }

        showModal();
      };

      const onUseThisTemplate = () => onUseThisTemplateClick(false, true);
      const onCustomizeTemplate = () => onCustomizeTemplateClick(false, true);

      return {
        canContinue,
        leaveModalShow,
        hideModal,
        onQuit,
        onGoBack,
        onFileUploadChange,
        clearPreview,
        formats,
        types,
        uploadAiTask,
        loading,
        uploadedFiles,
        aiTemplate,
        exitAction,
        onUseThisTemplate,
        onCustomizeTemplate,
        hasAiBalance,
        isAiPricingEnabled,
      };
    },
  });
